<template lang="pug">
  .box
    label(class="switchBtn")
        input(type="checkbox" @change="permissions" :value="isChecked" :checked="isChecked && isDisabled == false" :disabled="isDisabled")
        div(class="slide round")
</template>
<script>
export default {
  name: 'Toogle',
  data: () => ({
    checked: false
  }),
  props: {
    flag: {
      type: Boolean,
      default: false
    },
    masterSwitch: {
      type: Boolean,
      default: false
    },
    parent: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isChecked () {
      this.changeFlag()
      return this.flag
    }
  },
  methods: {
    permissions () {
      this.checked = !this.checked
      if (!this.masterSwitch) {
        if (this.checked) {
          this.$emit('permission')
        } else {
          this.$emit('delete')
        }
      } else {
        if (this.checked) {
          this.$emit('enableAll')
        } else {
          this.$emit('disableAll')
        }
      }
    },
    changeFlag () {
      this.checked = this.flag
    }
  }
}
</script>
<style lang="scss" scoped>
.switchBtn {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 20px;
}
.switchBtn input {display:none;}
.slide {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
    padding: 8px;
    color: #fff;
}
.slide:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    right: 21px;
    bottom: 2px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
}
input:checked + .slide {
    background-color: rgb(89, 211, 103);
    padding-left: 18px;
}
input:focus + .slide {
    box-shadow: 0 0 1px #01aeed;
}
input:checked + .slide:before {
    -webkit-transform: translateX(22px);
    -ms-transform: translateX(22px);
    transform: translateX(22px);
    right: 24px;
}
.slide.round {
    border-radius: 34px;
}
.slide.round:before {
    border-radius: 50%;
}
</style>
